"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResultDialog = exports.resultDialogContext = exports.defaultResultDialogContextValue = exports.ResultDialogProvider = void 0;
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
const defaultResultDialogContextValue = exports.defaultResultDialogContextValue = {
  open: false,
  snackbar: null,
  onClose:
  // istanbul ignore next @preserve -- default context value
  () => undefined,
  onOpen:
  // istanbul ignore next @preserve -- default context value
  () => undefined
};
const resultDialogContext = exports.resultDialogContext = /*#__PURE__*/(0, _react.createContext)(defaultResultDialogContextValue);
const ResultDialogProvider = ({
  children
}) => {
  const [feedbackDialogProps, setFeedbackDialogProps] = (0, _react.useState)({});
  const {
    open,
    onOpen: onOpenFromUseDisclose,
    onClose: onCloseFromUseDisclose
  } = (0, _presentationHooks.useDisclose)();
  const {
    openSnackbar,
    snackbar
  } = (0, _hooks.useSnackbar)();
  const onOpen = (0, _react.useCallback)(props => {
    if (props.content) {
      setFeedbackDialogProps(props);
      onOpenFromUseDisclose();
    } else if (props.header) {
      openSnackbar(props.header);
    }
  }, [onOpenFromUseDisclose, openSnackbar]);
  const onClose = (0, _react.useCallback)(() => {
    onCloseFromUseDisclose();
    setTimeout(() => setFeedbackDialogProps({}), 300);
  }, [onCloseFromUseDisclose]);
  const value = (0, _react.useMemo)(() => ({
    ...feedbackDialogProps,
    open,
    fullWidth: true,
    maxWidth: '450px',
    snackbar,
    onOpen,
    onClose
  }), [feedbackDialogProps, open, snackbar, onOpen, onClose]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(resultDialogContext.Provider, {
    value: value,
    children: children
  });
};
exports.ResultDialogProvider = ResultDialogProvider;
const useResultDialog = () => (0, _react.useContext)(resultDialogContext);
exports.useResultDialog = useResultDialog;
